import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=3b0c0da6&scoped=true"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"
import style0 from "./slideshow.vue?vue&type=style&index=0&id=3b0c0da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c0da6",
  null
  
)

export default component.exports